import {axiosInstance} from './rest';

export async function getSolutionGroupsName(textSearch) {
    let text_search = '';
    if (textSearch !== undefined && textSearch !== null) {
        text_search = textSearch;
    }
    return axiosInstance.get(`hdi/solutionGroup`, {params: {text_search}});
}
